"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var _ = __importStar(require("lodash"));
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var OrdersStore_1 = require("stores/OrdersStore");
var Breadcrumb_1 = __importDefault(require("components/common/navigation/Breadcrumb"));
var Select_1 = __importDefault(require("components/common/inputs/Select"));
var Notification_1 = require("../../Notification");
var product_error_icon_svg_1 = __importDefault(require("../../../res/img/product-error-icon.svg"));
var TableHeading_1 = require("../../common/table/TableHeading");
var Textarea_1 = __importDefault(require("../../common/inputs/Textarea"));
var TextInput_1 = __importDefault(require("../../common/inputs/TextInput"));
var ViewOrder = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = use_stores_1.useStores(), prefsStore = _b.prefsStore, ordersStore = _b.ordersStore, orderPageStore = _b.orderPageStore;
    var _c = react_1.useState(data.partialRefundNotes), partialRefundNotes = _c[0], setPartialRefundNotes = _c[1];
    var _d = react_1.useState(data.partialRefundValue), partialRefundValue = _d[0], setPartialRefundValue = _d[1];
    var params = react_router_dom_1.useParams();
    var notification = use_notification_1.useNotification();
    var setActive = function () {
        for (var _i = 0, _a = ordersStore.data; _i < _a.length; _i++) {
            var order = _a[_i];
            if (order.id === parseInt(params.id)) {
                setData(order);
                setPartialRefundNotes(order.partialRefundNotes);
                setPartialRefundValue(order.partialRefundValue);
            }
        }
    };
    react_1.useEffect(function () {
        if (ordersStore.data.length <= 0) {
            api_1.default.getShopOrders(prefsStore.data.ordersTable.page, prefsStore.data.ordersTable.perPage, (prefsStore.data.ordersTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.ordersTable.sort.name !== null ? prefsStore.data.ordersTable.sort.name : '-id'), prefsStore.data.ordersTable.search)
                .then(function (response) {
                ordersStore.setData(response.data.orders);
                orderPageStore.setData(response.data.pages);
                setActive();
            })
                .catch(api_1.catchHandler);
        }
        else {
            setActive();
        }
    }, [params.id, ordersStore.data]);
    var changeHandler = function (value) {
        api_1.default.patchShopOrder({
            id: data.id,
            status: value
        })
            .then(function (response) {
            ordersStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Order status has been updated'
            });
        })
            .catch(api_1.catchHandler);
    };
    var keyTimerRef = react_1.useRef(null);
    var keyUpHandler = function (e) {
        var value = e.currentTarget.value;
        var numberEx = /^[+-]?\d+(\.\d+)?$/;
        setPartialRefundNotes(value);
        if (value === '0')
            value = 0;
        else if (numberEx.test(value)) {
            value = Math.round(value * 100) / 100;
        }
        clearTimeout(keyTimerRef.current);
        keyTimerRef.current = setTimeout(function () {
            notesChangeHandler(value);
        }, 1000);
    };
    var keyUpHandler2 = function (e) {
        var value = e.currentTarget.value;
        var numberEx = /^[+-]?\d+(\.\d+)?$/;
        setPartialRefundValue(value);
        if (value === '0')
            value = 0;
        else if (numberEx.test(value)) {
            value = Math.round(value * 100) / 100;
        }
        clearTimeout(keyTimerRef.current);
        keyTimerRef.current = setTimeout(function () {
            valueChangeHandler(value);
        }, 1000);
    };
    var notesChangeHandler = function (value) {
        api_1.default.patchShopOrder({
            id: data.id,
            partialRefundNotes: value
        })
            .then(function (response) {
            ordersStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Notes have been updated'
            });
        })
            .catch(api_1.catchHandler);
    };
    var valueChangeHandler = function (value) {
        api_1.default.patchShopOrder({
            id: data.id,
            partialRefundValue: value
        })
            .then(function (response) {
            ordersStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Partial Refund value has been updated has been updated'
            });
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'view-order page' },
        data &&
            react_1.default.createElement(Breadcrumb_1.default, { items: [
                    { text: 'Orders', href: '/orders' },
                    {
                        text: data.altOrderNumber !== "" && data.altOrderNumber !== null ? data.altOrderNumber : data.orderNumber,
                        href: "/orders/" + data.id
                    }
                ] }),
        react_1.default.createElement("div", { className: 'view-order__basic' },
            react_1.default.createElement("span", { className: 'title' }, "Order Information"),
            react_1.default.createElement("div", { className: 'view-order__basic__details flex flex-row' },
                react_1.default.createElement("div", { className: 'half' },
                    react_1.default.createElement("div", { className: 'view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Order Number:"),
                        react_1.default.createElement("span", { className: 'value' }, data.altOrderNumber !== "" && data.altOrderNumber !== null ? data.altOrderNumber : data.orderNumber)),
                    react_1.default.createElement("div", { className: 'view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Order Date:"),
                        react_1.default.createElement("span", { className: 'value' }, dayjs_1.default(data.orderDate).format('DD/MM/YYYY'))),
                    react_1.default.createElement("div", { className: 'view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Order Status:"),
                        react_1.default.createElement(Select_1.default, { value: data.status, options: Object.values(OrdersStore_1.OrderStatus).map(function (status) { return ({
                                text: status,
                                value: status
                            }); }), onChange: changeHandler })),
                    data.status === OrdersStore_1.OrderStatus.PARTIAL_REFUNDED &&
                        react_1.default.createElement("div", { className: 'view-order__basic__row flex flex-row' },
                            react_1.default.createElement(Textarea_1.default, { name: "partialRefundNotes", value: partialRefundNotes, defaultValue: data.partialRefundNotes, onChange: keyUpHandler })),
                    data.status === OrdersStore_1.OrderStatus.PARTIAL_REFUNDED &&
                        react_1.default.createElement("div", { className: 'view-order__basic__row flex flex-row' },
                            react_1.default.createElement(TextInput_1.default, { type: 'number', name: 'partialRefundValue', altlabel: 'Refund Value', placeholder: '0.00', pattern: '^\\d*(\\.\\d{0,2})?$', min: 0, max: (parseFloat(data.orderTotal) - 0.01).toFixed(2), step: 0.01, value: partialRefundValue, onChange: keyUpHandler2, defaultValue: data.partialRefundValue })),
                    react_1.default.createElement("div", { className: 'view-order__basic__row address-row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Delivery Address:"),
                        react_1.default.createElement("address", { className: 'value' },
                            data.firstName,
                            " ",
                            data.lastName,
                            " ",
                            react_1.default.createElement("br", null),
                            data.addressLine1,
                            " ",
                            data.addressLine2,
                            " ",
                            react_1.default.createElement("br", null),
                            data.town,
                            ", ",
                            data.county,
                            " ",
                            react_1.default.createElement("br", null),
                            data.country,
                            " ",
                            react_1.default.createElement("br", null),
                            data.postcode,
                            " ",
                            react_1.default.createElement("br", null)))),
                react_1.default.createElement("div", { className: 'half' },
                    data.deliveryMethod && react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Delivery Method:"),
                        react_1.default.createElement("span", { className: 'value' }, data.deliveryMethod)),
                    data.deliveryCost && react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Delivery Cost:"),
                        react_1.default.createElement("span", { className: 'value' },
                            data.currency === 'priceAlt' ? '€' : '£',
                            data.deliveryCost)),
                    react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Items Total:"),
                        react_1.default.createElement("span", { className: 'value' },
                            data.currency === 'priceAlt' ? '€' : '£',
                            data.itemTotal)),
                    data.discountTotal !== null && data.discountTotal !== "0" &&
                        react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                            react_1.default.createElement("span", { className: 'label' }, "Discount Total:"),
                            react_1.default.createElement("span", { className: 'value' },
                                data.currency === 'priceAlt' ? '€' : '£',
                                data.discountTotal,
                                " ",
                                data.promoCodes !== undefined && data.promoCodes !== null ? (data.promoCodes[0] !== undefined ? '(' + data.promoCodes[0].code + ')' : '("Buy More, Save More"/Other)') : null)),
                    react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Order Total:"),
                        react_1.default.createElement("span", { className: 'value' },
                            data.currency === 'priceAlt' ? '€' : '£',
                            data.orderTotal)),
                    react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Customer Telephone:"),
                        react_1.default.createElement("span", { className: 'value' }, data.contactNumber || 'N/A')),
                    react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Customer Email Address:"),
                        react_1.default.createElement("span", { className: 'value' }, data.emailAddress)),
                    data.customer !== undefined && data.customer !== null &&
                        react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                            react_1.default.createElement("span", { className: 'label' }, "Customer Code:"),
                            react_1.default.createElement("span", { className: 'value' }, data.customer.customerCode)),
                    data.notes !== null && react_1.default.createElement("div", { className: ' view-order__basic__row flex flex-row' },
                        react_1.default.createElement("span", { className: 'label' }, "Notes:"),
                        react_1.default.createElement("span", { className: 'value' }, data.notes))))),
        react_1.default.createElement("div", { className: 'view-order__items' },
            react_1.default.createElement("span", { className: 'title' }, "Items"),
            react_1.default.createElement("div", { className: 'view-order__thead flex flex-row' },
                react_1.default.createElement("div", { className: 'image' }, "Image"),
                react_1.default.createElement("div", { className: 'name' }, "Name"),
                react_1.default.createElement("div", { className: 'code' }, "Code"),
                react_1.default.createElement("div", { className: 'options' }, "Options"),
                react_1.default.createElement("div", { className: 'quantity' }, "Quantity"),
                data.orderItems &&
                    data.orderItems[0].extraAttributes &&
                    Object.keys(data.orderItems[0].extraAttributes).map(function (key) { return (react_1.default.createElement("div", { className: 'ex-col', key: key }, _.startCase(key))); }),
                react_1.default.createElement("div", { className: 'total' }, "Total")),
            data.orderItems &&
                data.orderItems.map(function (item) { return (react_1.default.createElement("div", { className: 'view-order__item flex flex-row', key: item.id },
                    react_1.default.createElement("div", { className: 'image' },
                        react_1.default.createElement("img", { "data-error": item.product.images.length <= 0, src: item.product.images.length > 0 && item.product.images[0].thumbnail || product_error_icon_svg_1.default, alt: item.product.name })),
                    react_1.default.createElement("span", { className: 'name' }, item.product.name),
                    react_1.default.createElement("span", { className: 'code' }, item.code ? item.code : item.product.code),
                    react_1.default.createElement("span", { className: 'options' }, item.optionItemOptions &&
                        Object.keys(item.optionItemOptions).map(function (key) { return (react_1.default.createElement("small", null,
                            react_1.default.createElement("b", null, item.optionItemOptions[key].productOption.name),
                            ": ",
                            item.optionItemOptions[key].name)); })),
                    react_1.default.createElement("span", { className: 'quantity' },
                        "x",
                        item.quantity),
                    item.extraAttributes &&
                        Object.keys(item.extraAttributes).map(function (key) { return (react_1.default.createElement("div", { className: 'ex-col', key: key }, item.extraAttributes[key])); }),
                    react_1.default.createElement("span", { className: 'total' },
                        data.currency === 'priceAlt' ? "€" : "£",
                        item.total))); }))));
});
exports.default = ViewOrder;
